/**
 * Dev environment
 *
 * Put what you like in it, but DON'T use it to build prod !
 */
export const environment = {
  production: false,
  api: 'https://chat-api-new-pp.contactdve.com/api',
  graphQL: 'https://api.pp.weezchat.fr/graphql',
  chat: 'https://pp-chat-liveengine.contactdve.com/',

  waitingAPI: 'dating-notification-pp.dv-content.io/',
  waitingToken: 'TtD4dFtMCfu92eCK',
  gtm: 'GTM-PHD7MZX',
  gtmCountry: 'GTM-PP3KQKT',
  completeProfileInputs: ['email'],
  id: 'ck6ky8lfuay7u0b623vcm6b0m',
  dvp4m: true,
  gsv: null,

  appLink: null,
  didomi: 'rVC3Jw7w',
};
